import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Card } from 'reactstrap';
import _ from 'lodash';
import { parseAmount } from 'app/utils/parsers';

import SectionGroup from 'app/components/general/SectionGroup';

import * as teamPaymentRequestMetricsActions from 'app/ducks/teamPaymentRequestMetrics/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamPaymentRequestMetricsSelectors from 'app/ducks/teamPaymentRequestMetrics/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import { ITeamPaymentRequestMetricsSelector } from 'app/ducks/teamPaymentRequestMetrics/types';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    teamPaymentRequestMetrics: teamPaymentRequestMetricsSelectors.getTeamPaymentRequestMetrics(state),
    currentOrganisation: organisationsSelectors.getCurrentOrganisation(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.teamPaymentRequestMetrics.backendErrors },
  };
}

const actionCreators = _.merge(teamPaymentRequestMetricsActions);

interface IProps {
  teamId: string;
  groupId: string;
  appReady: any;
  teamPaymentRequestMetrics: ITeamPaymentRequestMetricsSelector;
  actions: any;
  currentOrganisation: any;
  isLoading: boolean;
  errors: any;
  setFilterStatus: Function;
}

interface IState {
  numberOfCards: number;
}

const DashboardPaymentRequestSummary: FC<IProps> = (props: IProps = {
  groupId: undefined,
  teamId: undefined,
  teamPaymentRequestMetrics: {},
  actions: undefined,
  currentOrganisation: {},
  isLoading: false,
  appReady: false,
  errors: {},
  setFilterStatus: undefined,
}) => {
  // const [numberOfCards, setNumberOfCards] = useState(4);
  // const [paymentStatus, setPaymentStatus] = useState('upcoming');

  useEffect(() => {
    props.actions.getAllTeamPaymentRequestMetrics(
      {
        filter: {
          'team-ids': props.teamId,
        },
        page: {
          size: 200,
        },
      },
      false,
    );
  }, [props.teamId]);

  return (
    <SectionGroup isLoading={props.teamPaymentRequestMetrics.isLoading && _.isEmpty(props.teamPaymentRequestMetrics.teamPaymentRequestMetricIds)} title="Your Payment Requests" noBorder>
      <div className="row">
        <div className="col col-md-12 col-lg-10 col-xl-8">
          <Card>
            <div className="row">
              <div
                onClick={() => {
                  if (props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.paidPaymentCollectionsTotalAmount !== 0) {
                    props.setFilterStatus('collected');
                  }
                }}
                className={classnames('col col-12 col-md-4 with-padding border-bottom-thick-success bottom-left-rounded no-padding-right metric-hover', { 'border-light': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.paidPaymentCollectionsTotalAmount === 0 })}
              >
                <div className="no-sm-border-bottom">
                  <h3 className={classnames('text-left padding-left', { 'text-grey': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.paidPaymentCollectionsTotalAmount === 0 })}>Collected</h3>
                  <h3 className={classnames('text-left padding-left margin-top margin-sm-top-10', { 'text-grey': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.paidPaymentCollectionsTotalAmount === 0 })}>{parseAmount(props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.paidPaymentCollectionsTotalAmount)}</h3>
                </div>
              </div>
              <div
                onClick={() => {
                  if (props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.pendingPaymentCollectionsTotalAmount !== 0) {
                    props.setFilterStatus('pending');
                  }
                }}
                className={classnames('col col-12 col-md-4 with-padding border-bottom-thick-warning no-padding-right no-padding-left metric-hover', { 'border-light': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.pendingPaymentCollectionsTotalAmount === 0 })}
              >
                <div className="with-border-right with-border-left no-sm-border-bottom">
                  <h3 className={classnames('text-left padding-left-extra', { 'text-grey': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.pendingPaymentCollectionsTotalAmount === 0 })}>Outstanding</h3>
                  <h3 className={classnames('text-left padding-left-extra margin-top margin-sm-top-10', { 'text-grey': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.pendingPaymentCollectionsTotalAmount === 0 })}>{parseAmount(props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.pendingPaymentCollectionsTotalAmount)}</h3>
                </div>
              </div>
              <div
                onClick={() => {
                  if (props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.overduePaymentCollectionsTotalAmount !== 0) {
                    props.setFilterStatus('overdue');
                  }
                }}
                className={classnames('col col-12 col-md-4 with-padding border-bottom-thick-error bottom-right-rounded metric-hover', { 'border-light': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.overduePaymentCollectionsTotalAmount === 0 })}
              >
                <div>
                  <h3 className={classnames('text-left padding-left', { 'text-grey': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.overduePaymentCollectionsTotalAmount === 0 })}>Overdue</h3>
                  <h3 className={classnames('text-left padding-left margin-top margin-sm-top-10', { 'text-grey': props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.overduePaymentCollectionsTotalAmount === 0 })}>{parseAmount(props.teamPaymentRequestMetrics?.currentTeamPaymentRequestMetric?.overduePaymentCollectionsTotalAmount)}</h3>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
      {/* <div className="row margin-top margin-sm-top-10-10">
        <div className="col text-left">
          <Link className="btn-2 btn-thin d-inline-flex align-content-center" to="/list-payments">
            View all payment requests
            {' '}
            <Isvg className="right-arrow-icon" src={ArrowRightIcon} />
          </Link>
        </div>
      </div> */}
    </SectionGroup>
  );
};
export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(DashboardPaymentRequestSummary);
